import { render, staticRenderFns } from "./UpgradeSuggestion.vue?vue&type=template&id=79bb1782&scoped=true"
import script from "./UpgradeSuggestion.vue?vue&type=script&lang=js"
export * from "./UpgradeSuggestion.vue?vue&type=script&lang=js"
import style0 from "./UpgradeSuggestion.vue?vue&type=style&index=0&id=79bb1782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bb1782",
  null
  
)

export default component.exports